export default function Panel(props: any) {
  const { children } = props;
  return (
    <div className="panel" {...props}>
      {children}
    </div>
  );
}
